import { call, put } from 'redux-saga/effects'
import api from 'lib/api/client'
import { receiveLocations } from './actions'

export default function * (token) {
  const locations = yield call(
    api.get, '/locations?active=true', { token }
  )

  yield put(receiveLocations(locations))
}
